import Header from '../components/Header';
import Footer from '../components/Footer';
import Impact from '../components/Impact';
import React from 'react';
const AboutUs = () => {
    return (
        <div>
            
             <Header/> 
      
            <div>
                <div className="page-heading header-text">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <h1>About Us</h1>
                                <span>Discover Our Journey: Building Tomorrow's Tech Leaders Together</span>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="more-info about-info">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="more-info-content">
                                    <div className="row">
                                        <div className="col-md-6 align-self-center">
                                            <div className="right-content">
                                                <span>Innovation Through Collaboration</span>
                                                <h2>Get to know about <em>Creative Lab ISI</em></h2>
                                                <p>
                                                    Creative Lab ISI Ariana is a vibrant IT club at Institut Supérieur Informatique, founded with a simple yet powerful mission: to share knowledge and foster collaborative learning among aspiring technologists. Located at 2 Rue Abou Raihane Bayrouni, Ariana, Tunisia, our club serves as a bridge between academic theory and real-world application.
                                                    <br/><br/>
                                                    We organize technical workshops, coding competitions, community service projects, and networking events that help students develop both technical skills and social responsibility. With over 535 followers on Instagram (@creative_lab_isi) and an active presence on Facebook, we've built a community that extends beyond the classroom walls.
                                                    <br/><br/>
                                                    Contact us at creative.lab.club@gmail.com or //to add the url to join our mission of building tomorrow's tech leaders through knowledge sharing and collaborative innovation.
                                                </p>
                                            </div>
                                        </div>
                                        <div className="col-md-6">
                                            <div className="left-image" style={{backgroundColor:'#CFDEE7'}}>
                                                <img src="assets/images/coloredLogo.png" alt="Creative Lab Team" style={{ width: '100%', height: 'auto' }} />
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="team">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12">
                                <div className="section-heading">
                                    <h2>Our core <em>team</em></h2>
                                    <span>
                                        Creative Lab ISI Ariana is led by passionate students and recent graduates who believe in the power of collaborative learning and knowledge sharing. Our leadership team combines technical expertise with a genuine commitment to building an inclusive community where every member can grow and contribute. From organizing Flutter workshops to coordinating community service projects like our Ramadan iftar initiative, our team works tirelessly to create opportunities that bridge the gap between academic learning and real-world impact.
                                    </span>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="team-item">
                                    
                                    <div className="down-content" style={{marginLeft: '100px', width: '50%', height: 'auto' }}>
                                        <h4>Ayyoub Issaui</h4>
                                        <span>Club President</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="team-item">
                                    
                                    <div className="down-content" style={{ marginLeft: '100px', width: '50%', height: 'auto'}}>
                                        <h4>Molka Ben Sdira</h4>
                                        <span>Vice President</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="team-item">
                                    
                                    <div className="down-content" style={{marginLeft: '100px', width: '50%', height: 'auto' }}>
                                        <h4>Hamdi Bouzid</h4>
                                        <span>General Secretary</span>
                                    </div>
                                </div>
                            </div>
                            
                            
                        </div>
                    
                    
                        <div className="row" style={{marginTop:"10%"}}>
                            <div className="col-md-4">
                                <div className="team-item">
                                    
                                    <div className="down-content" style={{marginLeft: '100px', width: '50%', height: 'auto' }}>
                                        <h4>Yasmine Labassi</h4>
                                        <span>HR Manager</span>
                                    </div>
                                </div>
                            </div>
                            
                            <div className="col-md-4">
                                <div className="team-item">
                                    <div className="down-content" style={{marginLeft: '100px', width: '50%', height: 'auto' }}>
                                        <h4>Islem Ben Youssef</h4>
                                        <span>Media Manager</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="team-item">
                                    <div className="down-content" style={{marginLeft: '100px', width: '50%', height: 'auto' }}>
                                        <h4>Zoubair Ben Salah</h4>
                                        <span>Treasurer</span>
                                    </div>
                                </div>
                            </div>
                            
                            
                            
                            
                        </div>
                        <div className="row" style={{marginTop:"10%"}}>
                            <div className="col-md-4">
                                <div className="team-item">
                                    <div className="down-content" style={{marginLeft: '100px', width: '50%', height: 'auto' }}>
                                        <h4>Youssef Bouyahia</h4>
                                        <span>Robotics Team lead</span>
                                    </div>
                                </div>
                            </div>

                            <div className="col-md-4">
                                <div className="team-item">
                                    <div className="down-content" style={{marginLeft: '100px', width: '50%', height: 'auto' }}>
                                        <h4>Mariem Bouchendira</h4>
                                        <span>Dev Team lead</span>
                                    </div>
                                </div>
                            </div>
                            <div className="col-md-4">
                                <div className="team-item">
                                    <div className="down-content" style={{marginLeft: '100px', width: '50%', height: 'auto' }}>
                                        <h4>Rayen Ben Ali</h4>
                                        <span>Media Assistant</span>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                        <div className="row" style={{marginTop:"10%"}}>
                            <div className="col-md-4">
                                <div className="team-item">
                                    <div className="down-content" style={{marginLeft: '100px', width: '50%', height: 'auto' }}>
                                        <h4>Ahmed Chafra</h4>
                                        <span>RH Assistant</span>
                                    </div>
                                </div>
                            </div>

                            
                            
                        </div>
                    </div>
                    

                    
                </div>
            </div>
            
            <Impact/>
            <Footer/>
        </div>
    );
};
export default AboutUs;